// Core
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Components
import {
  NavigationTabs,
  NavigationTabsProps,
} from '../../../../../../layout/elements/NavigationTabs';

// Modules
import { IFMStatus } from './Modules/IFMStatus/IFMStatus';

// View
import { IFMProps, IFMType } from './IFM.types';
import {
  Container,
  FixedHeader,
  ScrollableContent,
  Separator,
} from './IFM.style';
import { ASINetwork } from './Modules/ASI';

function IFM({
  className,
  onChangeView,
  unitData,
  edgeStatus,
  selectedView,
  testId,
}: IFMProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();

  const changeIFMStatus: NavigationTabsProps['items'] = [
    { key: IFMType.ifm, label: t('view.crusher.maintenance.ifm.tabs.modulesStatus') },
    { key: IFMType.asiNetwork, label: t('view.crusher.maintenance.ifm.tabs.asiNetwork') },
  ];

  const renderContent = (): JSX.Element => {
    switch (selectedView) {
      case IFMType.ifm:
        return <IFMStatus unitData={unitData} edgeStatus={edgeStatus} />;
      case IFMType.asiNetwork:
        return <ASINetwork unitData={unitData} edgeStatus={edgeStatus} />;
      default:
        return <IFMStatus unitData={unitData} edgeStatus={edgeStatus} />;
    }
  };

  return (
    <Container className={className} data-testid={testId}>
      <FixedHeader>
        <NavigationTabs
          items={changeIFMStatus}
          onClick={onChangeView}
          selected={selectedView}
        />
        <Separator />
      </FixedHeader>
      <ScrollableContent>{renderContent()}</ScrollableContent>
    </Container>
  );
}

export { IFM };
